import { BriefcasePlusIcon } from './BriefcasePlusIcon';

/**
 * author: Michael Irigoyen
 * id C08C7899-5B7E-4E6F-9861-C319CFABA7DC
 * name briefcase-plus
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-plus.svg
 * tags
 */
export const BriefcaseAddIcon = BriefcasePlusIcon;
export default BriefcaseAddIcon